import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { formatNumber, unformatNumber } from "utils/utils";
import {
  clearCashierSessionData,
  getCashierLocation,
} from "utils/locationUtils";
import { useTransaction } from "../History/TransactionContext";

const CloseCasirPage = ({
  initialData,
  onSuccess,
  onError,
  cashierSessions,
}) => {
  const API_URL = "/cashier-session/closed";
  // const { products, refetch } = useProduct();
  console.log("Initial Data", initialData);
  const { transactions } = useTransaction();

  // Menambahkan state untuk menyimpan products
  const [formData, setFormData] = useState({
    balance: "",
    location: "", // Tambahkan location
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "cashier-session/closeds"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "cashier-session/closeds"
  );

  // Gunakan hook untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      balance: unformatNumber(formData.balance), // Unformat balance value before sending
    };

    // Hapus location-specific session data setelah close cashier
    const currentLocation = getCashierLocation();
    if (currentLocation) {
      clearCashierSessionData(currentLocation);
    }

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // Jika initialData tersedia, isi form untuk update
    if (initialData) {
      setFormData({
        ...initialData,
      });
    } else {
      // Load location dari localStorage using locationUtils
      const savedLocation = getCashierLocation();
      if (savedLocation) {
        setFormData((prev) => ({
          ...prev,
          location: savedLocation,
        }));
      }
    }
  }, [initialData]);

  // useEffect(() => {
  //   if (initialData) {
  //     setFormData({
  //       ...initialData,
  //     });
  //   } else {
  //     // Hitung balance otomatis dari transaksi yang sesuai
  //     const totalBalance = transactions
  //       .filter((tx) => tx.cashier_session_id === cashierSessions?.id)
  //       .reduce((sum, tx) => sum + parseFloat(tx.grand_total), 0);

  //     setFormData((prev) => ({
  //       ...prev,
  //       balance: formatNumber(totalBalance), // Format number (ex: 570,850)
  //     }));
  //   }
  // }, [initialData, transactions, cashierSessions]);

  // Handler khusus untuk input balance agar selalu terformat ribuan saat diketik
  const handleBalanceChange = (e) => {
    const { value } = e.target;
    // Hanya angka
    const number = value.replace(/[^\d]/g, "");
    // Format ribuan
    const formatted = number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    setFormData((prev) => ({ ...prev, balance: formatted }));
  };

  // Hitung total transaksi sesuai cashierSessions
  // const calculatedBalance = formatNumber(
  //   transactions
  //     .filter((tx) => tx.cashier_session_id === cashierSessions?.id)
  //     .reduce((sum, tx) => sum + parseFloat(tx.grand_total), 0)
  // );
  const CASH_PAYMENT_METHOD_ID = "9e77ac94-cb18-4c81-a324-18700c1160da";

  const calculatedBalance = formatNumber(
    transactions
      .filter(
        (tx) =>
          tx.cashier_session_id === cashierSessions?.id &&
          tx.payment_method_id === CASH_PAYMENT_METHOD_ID
      )
      .reduce((sum, tx) => sum + parseFloat(tx.grand_total), 0)
  );

  const locationsOptions = [
    { value: "bar", label: "Bar" },
    { value: "coffee_shop", label: "Coffee Shop" },
    { value: "merchandise", label: "Merchandise" },
  ];

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Display current location from localStorage */}
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Current Location:
          </label>
          <div className="col-sm-8">
            <div
              className="form-control form-control-sm bg-light"
              style={{
                fontSize: "14px",
                height: "35px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {formData.location ? (
                <>
                  {formData.location === "bar" && (
                    <span role="img" aria-label="Bar" className="me-2">
                      🍸
                    </span>
                  )}
                  {formData.location === "coffee_shop" && (
                    <span role="img" aria-label="Coffee" className="me-2">
                      ☕
                    </span>
                  )}
                  {formData.location === "merchandise" && (
                    <span role="img" aria-label="Merchandise" className="me-2">
                      🛍️
                    </span>
                  )}
                  {locationsOptions.find(
                    (opt) => opt.value === formData.location
                  )?.label || formData.location}
                </>
              ) : (
                <span className="text-muted">No location set</span>
              )}
            </div>
          </div>
        </div>

        {/* Sistem kalkulasi */}
        <div className="row mb-3 align-items-center">
          <label
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Calculated Balance:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control gotra-form-control rounded-1"
              value={calculatedBalance}
              readOnly
              disabled
              style={{
                fontSize: "14px",
                height: "35px",
                backgroundColor: "#e9ecef",
              }}
            />
          </div>
        </div>
        {/*  balance */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Input cash hari ini:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.balance && "is-invalid"
              )}
              id="balance"
              placeholder=" balance"
              name="balance"
              value={formData.balance}
              onChange={handleBalanceChange}
              // onFocus={handleFocus} // Convert back to number when focused
              // onBlur={handleBlur} // Format when focus is lost
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              // minLength={3}
            />
            {formError?.balance && (
              <div className="invalid-feedback">{formError.nabalanceme}</div>
            )}
          </div>
        </div>
      </div>
      {/* print json cashierSessions */}
      {/* {cashierSessions && (
        <pre className="text-muted" style={{ fontSize: "12px" }}>
          {JSON.stringify(cashierSessions, null, 2)}
        </pre>
      )} */}

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update" : "Balance"}
        </button>
      </div>
    </form>
  );
};

export default CloseCasirPage;
